import api from './axios';

export async function fetchMyGeneralAssessment(reviewTypeId) {
    const { data } = await api.get('/api/contract-review-summaries/mine', {
        params: { review_type_id: reviewTypeId },
    });
    return data; // { contract, review_type_id, summary }
}

export async function fetchManagedGeneralAssessment(reviewTypeId, employeeId) {
    const { data } = await api.get('/api/contract-review-summaries/managed', {
        params: { review_type_id: reviewTypeId, employee_id: employeeId },
    });
    return data;
}

export async function updateGeneralAssessmentEmployee(id, payload) {
    const { data } = await api.put(`/api/contract-review-summaries/${id}`, payload);
    return data;
}

export async function updateGeneralAssessmentManager(id, payload) {
    const { data } = await api.put(`/api/contract-review-summaries/${id}/manager`, payload);
    return data;
}
